import {IEventData} from 'coreClasses/events/IEvents';
import {IAnalyticsEvent} from 'coreClasses/analytics/IAnalytics';

import {EAnalyticsEventType} from 'brandClasses/analytics/EAnalyticsEvent';

import CartInfoModel from './common/CartInfoModel';

/**
 * Represents CartUpdatedEvent
 */
export default class CartUpdatedEvent implements IAnalyticsEvent {
	public event: string;
	public event_trigger: string;
	public ecommerce: any;
	public cart_info: any;
	/**
	 * @constructor
	 * @param {IEventData} data - data
	 */
	constructor(data: IEventData) {
		this.event = EAnalyticsEventType.CART_UPDATED;
		this.cart_info = data.basket && new CartInfoModel(data.basket);
		this.event_trigger = 'ecomm';
	}
}
